import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=5ea490ba&"
import script from "./PostComments.vue?vue&type=script&lang=ts&"
export * from "./PostComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports